export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyCGUxvBkzpTP4zprC6Ehd8jOXCvBz-byhU',
    authDomain: 'yingfung-d9fac.firebaseapp.com',
    databaseURL: 'https://yingfung-d9fac.firebaseio.com',
    projectId: 'drivec-ba479',
    storageBucket: 'yingfung-d9fac.appspot.com',
    messagingSenderId: '463647462563',
  },  
};
export const CHATGPT_KEY = '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'
export const SERVER_URL = 'https://dev.drivebusinessintelligence.com';